import msgIcon1 from "../../../../assets/images/svg/msg_icon-1.svg";
import CustomLink from "../../../../components/Common/buttons/CustomLink";

import { getTaskNotificationDesc } from "components/CommonForBoth/TopbarDropdown/constants";

const TaskRenderer = ({ notification, classes }) => (
  <div className={classes.msgItem} key={`${notification.id}-${notification.timestamp}`}>
    <img src={msgIcon1} alt="msgIcon" />
    <div className={classes.wrapText}>
      <CustomLink underlined to="/operations/tasks/intervention-call">
        <b>{notification.name}</b>
      </CustomLink>
      <br />
      {getTaskNotificationDesc(notification)}
    </div>
  </div>
);

export default TaskRenderer;
